import React from "react";

interface SuperOneLogoTextProps {
  className?: string;
  variant?: "light" | "dark";
}

export function SuperOneLogoText({
  className = "",
  variant = "dark",
}: SuperOneLogoTextProps) {
  // Use different color approach based on variant
  const logoStyle =
    variant === "dark"
      ? {
          backgroundImage:
            "linear-gradient(to right, white, rgba(255, 255, 255, 0.9))",
        }
      : {
          backgroundImage:
            "linear-gradient(to right, rgb(32, 40, 66), rgb(32, 40, 66))",
        };

  return (
    <div className={`flex items-center ${className}`}>
      <div className="flex items-center">
        {/* superone text, using Gotham Bold font */}
        <span
          className="text-transparent bg-clip-text text-2xl font-bold tracking-tighter leading-none"
          style={logoStyle}
        >
          superone
        </span>
      </div>
    </div>
  );
}
